module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX29vaSwPPy8/bd6fXZ5vXh6/XE2/SWw/Nxr/NoqvJUn/JSnvLG3PSu0PN4svPq8PXN4PS71vPbrYmGAAAAbklEQVQY02WPWQ7AIAhEQVTcqu39L1tZmjTxfWgcHBhAiFxbqxzBCNgxE+V9BX3PkkBJZYqCRc57Sa3g9netX6R/egRGcEFAhpr/Qq7QyIRnjLGA2ifE4YJYHLd4UwdZxyo+1oIJFuyIfi53rP8CyPgDPOfqAR4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/系统管理员 copy.png
// module id = 1366
// module chunks = 5